export const eccomerseDao = '0xcdBdC33bA9396d5C8575524b2654797Ab7D2Bb4e';
export const paySaleBUSD = "0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee"

